import { TableColumn } from "react-data-table-component";
import { TrainingVersion } from "../../../../core/trainingVersion/entities/TrainingVersion";
import { TranslationFunction } from "../../../../utils/utils";
import { boolBadgeClasses } from "../../../constants/badgeClasses";

const trainingVersionTableConfig = (
  t: TranslationFunction
): TableColumn<TrainingVersion>[] => [
  {
    name: "trainingVersion.field.rank",
    selector: (row: TrainingVersion) => row.rank ?? "",
    width: "60px",
    sortable: true,
  },
  {
    name: "trainingVersion.field.title",
    selector: (row: TrainingVersion) => row.title,
  },
  {
    name: "trainingVersion.field.description",
    selector: (row: TrainingVersion) => row.description ?? "",
  },
  {
    name: "trainingVersion.field.isAvailable",
    selector: (row: TrainingVersion) =>
      row.isAvailable ? t("common.yes") : t("common.no"),
    width: "100px",
    cell: (row: TrainingVersion) => {
      return (
        <span className={boolBadgeClasses(row.isAvailable)}>
          {row.isAvailable ? t("common.yes") : t("common.no")}
        </span>
      );
    },
  },
];

export default trainingVersionTableConfig;
